import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { CreditCard, ExternalLink } from 'lucide-react';
import { Card } from './ui/card';

const PayPalPayment = ({ amount, open, onClose, onSuccess, rideFare }) => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  
  const PAYPAL_LINK = 'https://www.paypal.me/BrandsMarket';
  
  const handlePayPalPayment = () => {
    const amountUSD = (rideFare / 2800).toFixed(2);
    const paypalUrl = `${PAYPAL_LINK}/${amountUSD}`;
    
    window.open(paypalUrl, '_blank');
    
    setTimeout(() => {
      onSuccess?.();
      onClose();
    }, 3000);
  };
  
  const handleCashPayment = () => {
    onSuccess?.();
    onClose();
  };
  
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {isArabic ? 'اختر طريقة الدفع' : 'Choose Payment Method'}
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <Card className="p-4 bg-gray-50">
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-gray-700">{isArabic ? 'أجرة الرحلة' : 'Ride Fare'}</span>
                <span className="text-2xl font-bold text-black">
                  {rideFare?.toLocaleString()} {isArabic ? 'ل.س' : 'SYP'}
                </span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">{isArabic ? 'بالدولار الأمريكي' : 'In USD'}</span>
                <span className="font-medium text-gray-900">
                  ${(rideFare / 2800).toFixed(2)} USD
                </span>
              </div>
            </div>
          </Card>
          
          <div className="space-y-3">
            <Button
              className="w-full bg-blue-600 hover:bg-blue-700 h-16 text-lg"
              onClick={handlePayPalPayment}
            >
              <CreditCard className="mr-2 h-5 w-5" />
              {isArabic ? 'الدفع عبر PayPal' : 'Pay with PayPal'}
              <ExternalLink className="ml-2 h-4 w-4" />
            </Button>
            
            <Button
              variant="outline"
              className="w-full h-16 text-lg border-2"
              onClick={handleCashPayment}
            >
              {isArabic ? 'الدفع نقداً للسائق' : 'Pay Cash to Driver'}
            </Button>
          </div>
          
          <div className="text-xs text-center text-gray-500 mt-4">
            {isArabic 
              ? '* سيتم فتح رابط PayPal في نافذة جديدة. أكمل الدفع وعد هنا.'
              : '* PayPal link will open in a new window. Complete payment and return here.'
            }
          </div>
          
          <div className="text-xs text-center text-gray-600 bg-gray-50 p-3 rounded-lg">
            {isArabic 
              ? `💰 رسوم المنصة: ${(rideFare * 0.2).toLocaleString()} ل.س (20%)`
              : `💰 Platform Fee: ${(rideFare * 0.2).toLocaleString()} SYP (20%)`
            }
            <br />
            {isArabic
              ? `السائق يحصل على: ${(rideFare * 0.8).toLocaleString()} ل.س (80%)`
              : `Driver receives: ${(rideFare * 0.8).toLocaleString()} SYP (80%)`
            }
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PayPalPayment;
